/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiClientEnterprise } from '@helpers/apiClients';
import { useModalState } from '@hooks';
import { GridValidRowModel } from '@mui/x-data-grid';
import { successMessage } from '@services';
import { useState } from 'react';
import { useMutation } from 'react-query';
import { useParams } from 'react-router-dom';
import { TableEnterpriseNewsWire } from '../constants';
import { queryClient } from '@helpers';
import QueryKeys from '@constants/query-keys';

const defaultItem = {
  id: '',
  title: '',
  url: '',
  label: '',
  imageUrl: null,
  createdAt: new Date().toISOString(),
  publishedAt: new Date().toISOString(),
};

export const useNewsWireManager = () => {
  const [isOpen, , openModal, onClose] = useModalState(false);
  const [editingItem, setEditingItem] = useState<TableEnterpriseNewsWire>(defaultItem);
  const { id: organizationId } = useParams<{ id: string }>();
  const { mutate: deleteAsset } = useMutation<unknown, unknown, string[]>(
    (newsWireUuids: string[]) =>
      ApiClientEnterprise.delete(`/enterprises-admin/${organizationId}/newswire`, {
        data: { newsWireUuids },
      }),
    {
      onSuccess: () => {
        successMessage('Newswire has been removed!');
        queryClient.invalidateQueries(QueryKeys.enterpriseNewsWire);
      },
    },
  );

  const onEdit = (row: GridValidRowModel) => {
    setEditingItem(row as TableEnterpriseNewsWire);
    openModal();
  };

  const onDelete = (row: GridValidRowModel) => {
    deleteAsset([row.id]);
  };

  return {
    defaultItem,
    isOpen,
    openModal,
    onClose,
    editingItem,
    setEditingItem,
    onEdit,
    onDelete,
    organizationId,
  };
};
